import { render, staticRenderFns } from "./CommunityFilterWithSecondaryOptions.vue?vue&type=template&id=f972d3ae&scoped=true&"
import script from "./CommunityFilterWithSecondaryOptions.vue?vue&type=script&lang=js&"
export * from "./CommunityFilterWithSecondaryOptions.vue?vue&type=script&lang=js&"
import style0 from "./CommunityFilterWithSecondaryOptions.vue?vue&type=style&index=0&id=f972d3ae&lang=scss&scoped=true&"
import style1 from "./CommunityFilterWithSecondaryOptions.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f972d3ae",
  null
  
)

export default component.exports